import { Options, Vue } from 'vue-class-component'
import HeaderComponent from "@/components/header/HeaderComponent.vue";
import Modal from "@/components/Modal.vue";
import CopyrightTermsModal from "@/components/copyright-terms-modal/CopyrightTermsModal.vue";
import {version} from "../../../package.json";
import Loading from 'vue-loading-overlay';

@Options({
  data: function() {
    return {
      modalTitle: '',
      modalDescription: '',
      modalVisible: false,
      sidebarVisible: false,
      showCopyrightTermsModal: false,
      currentProjectVersion: version
    }
  },
  components: {
    Loading,
    Modal,
    HeaderComponent,
    CopyrightTermsModal
  },
  methods: {
    openRDForm() {
      document.getElementById('rd-floating_button-l9pznxxg')?.click();
    },
    toggleWorkUs(){
      document.getElementById('work-with-us')?.classList.toggle('active');
    },
    closeSidebar() {
      this.sidebarVisible = false;
    },
    openPhoneModal() {
      this.modalDescription = "0800 000 1878";
      this.modalVisible = true;
    },
    openCopyrightTermsModal() {
      this.showCopyrightTermsModal = true;
      this.modalTitle = this.$t('copyrightTerms');
    },
    openWhatsAppModal() {
      this.modalTitle = "WhatsApp";
      this.modalDescription = "+55 31 99535-1236";
      this.modalVisible = true;
    }
  },
  computed: {
    spacingTop(): boolean {
      return this.$route.meta.spacingTop;
    },
    solidBackground(): boolean {
      return this.$route.meta.solidBackground;
    },
    noSpacingBottom(): boolean {
      return this.$route.meta.noSpacingBottom;
    },
    fullWidth(): boolean {
      return this.$route.meta.fullWidth;
    }
  }
})
export default class App extends Vue {}
